// Components/Services/TakeoverProjects/FullTakeoverPage.jsx
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import HeroSection from "./HeroSection";
import ProcessSection from "./ProcessSection";
import WhoItsFor from "./WhoItsFor";
import WhoWeAre from "../AboutUs/WhoWeAre";
import FinalCTA from "../HomePage/FinalCTA";
import TakeoverProjectsOverview from "./TakeoverProjectsOverview";
import Overview from "../ADU&newcustomhome/OverView";
import HomeRemodelOverview from "../FullHomeRemodel/HomeRemodelOverview";
import HOACommercialOverview from "../HOACommercial/HOACommercialOverview";
import ADUPortfolio from "../ADU&newcustomhome/ADUPortfolio";
import HomeRemodelPortfolio from "../FullHomeRemodel/HomeRemodelPortfolio";
import TakeoverOtherServices from "./TakeoverOtherServices";
import HOAPortfolio from "../HOACommercial/HOAPortfolio";

export default function FullTakeoverPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Specialty Takeover Projects | Ashlar Building Group</title>
        <meta
          name="description"
          content="Ashlar Building Group specializes in construction takeover projects across California. Stalled builds, failed contractors, code violations, and budget overruns — we step in, assess, fix, and finish."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.ashlarbuildinggroup.com/services/takeover-projects" />

        {/* Open Graph */}
        <meta property="og:title" content="Specialty Takeover Projects | Ashlar Building Group" />
        <meta
          property="og:description"
          content="Failed contractor? Stalled build? Code violations? We step in, assess the damage, and take your project across the finish line. Trusted by homeowners, investors, and attorneys."
        />
        <meta property="og:image" content="/Images/Ground-Up-custom.png" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.ashlarbuildinggroup.com/services/takeover-projects" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Specialty Takeover Projects | Ashlar Building Group" />
        <meta
          name="twitter:description"
          content="Licensed California contractor specializing in construction takeovers — stalled builds, defect correction, and project completion."
        />
        <meta name="twitter:image" content="/Images/Ground-Up-custom.png" />

        {/* Schema */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "HomeAndConstructionBusiness",
            "name": "Ashlar Building Group",
            "url": "https://www.ashlarbuildinggroup.com",
            "logo": "https://www.ashlarbuildinggroup.com/Images/logo.png",
            "description": "California general contractor specializing in construction takeover projects — stalled builds, failed contractor remediation, code violation correction, and project completion.",
            "telephone": "+19256557741",
            "email": "info@ashlarbuilding.com",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "6200 Stoneridge Mall Rd",
              "addressLocality": "Pleasanton",
              "addressRegion": "CA",
              "postalCode": "94588",
              "addressCountry": "US"
            },
            "areaServed": ["Bay Area", "Orange County", "Los Angeles", "San Diego"],
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Takeover Project Services",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Stalled Project Takeover",
                    "description": "Step in and complete abandoned or stalled construction projects."
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Construction Defect Remediation",
                    "description": "Identify, document, and correct construction defects and code violations."
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Failed Contractor Recovery",
                    "description": "Take over from failed or abandoned contractors and deliver project completion."
                  }
                }
              ]
            }
          }
        `}</script>
      </Helmet>

      <HeroSection />
     <TakeoverProjectsOverview/>
      <ProcessSection />
      <WhoItsFor />
      <TakeoverOtherServices/>
      <Overview/>
      <ADUPortfolio/>
      <HomeRemodelOverview/>
      <HomeRemodelPortfolio/>
      <HOACommercialOverview/>
      <HOAPortfolio/>
      <WhoWeAre />
      <FinalCTA />
    </>
  );
}